/** 从prop传入渲染函数 或者字符串 或者prop同名插槽 */
export const getVNodeFromProp = (instance, prop) => {
  const temp = instance[prop];
  if (temp !== undefined) return typeof temp === 'function' ? temp(instance.$createElement) : temp;
  return instance.$slots[prop] || undefined;
};
//# sourceMappingURL=util.js.map
